import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '1.875rem'
});
